<template>
  <d-navbar-nav class="border-left flex-row">
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle text-nowrap px-3"
        v-d-toggle.user-actions
      >
        <img
          class="user-avatar rounded-circle mr-2"
          src="@/assets/images/avatars/0.jpg"
          alt="User Avatar"
        />
        <span class="d-none d-md-inline-block">Siu Mei Chan</span>
      </a>
      <div v-on:click="Logout">
      <d-collapse id="user-actions" class="dropdown-menu dropdown-menu-small" >
        <d-dropdown-item href="#" class="text-danger" >
          <span class="d-none d-md-inline-block" >
            <i class="material-icons text-danger">&#xE879;</i> Logout
          </span>
        </d-dropdown-item>
      </d-collapse>
      </div>
    </li>
  </d-navbar-nav>
</template>

<style>
.nav-link:hover {
  cursor: pointer;
}
</style>
<script>
import axios from "axios";

export default {
  methods: {
    async Logout() {
      await axios
        .delete(process.env.VUE_APP_SERVICE_URL + `api/auth/User/signout`, {
          data: {
            refreshToken: localStorage["refreshToken"],
          },
        })
        .then((response) => {
          
        })
        .catch((err) => {
          
        });
      this.$router.push({ name: "login" });
      localStorage.clear();
    },
  },
};
</script>